let bLazyProjects;

function buildApartmentVisualizationComponent(element, apartmentId) {
    const urlParams = new URLSearchParams(window.location.search);
    const activeTab = urlParams.get('activeTab') || 0;
    const activeVisualisationTab = urlParams.get('activeVisualisationTab') || 0;
    const productsPage = urlParams.get('productsPage') || 1;
    const apartmentProductsPage = urlParams.get('apartmentProductsPage') || 1;

    new Vue({
        el: element,
        store,
        data: {
            apartmentId: apartmentId,
            isLoaded: false,
            activeTab: activeTab,
            allVisualizations: [],
            activeVisualizationIndex: activeVisualisationTab,
            pagerModulus: 1,
            productsPerPage: 20,
            productsUrl: '/produkty-z-vizualizacii/' + apartmentId,
            productsFetched: false,
            apartmentProductsUrl: '/produkty-izby/' + apartmentId,
            apartmentProductsFetched: false,
            products: [],
            allProductsCount: 0,
            apartmentProducts: [],
            apartmentProductsCount: 0,
            initialProductsPage: productsPage,
            initialApartmentProductsPage: apartmentProductsPage,
        },
        created: function () {
            this.fetchVisualizations();

            window.addEventListener('popstate', function (event) {
                const url = new URL(window.location.href);
                const activeTab = url.searchParams.get('activeTab') || 0;

                if (activeTab != this.activeTab) {
                    this.activeTab = activeTab;
                }

                const activeVisualisationTab = url.searchParams.get('activeVisualisationTab') || 0;

                if (activeVisualisationTab != this.activeVisualizationIndex) {
                    this.activeVisualizationIndex = activeVisualisationTab;
                }
            }.bind(this));
        },
        components: {
            'app-paginator': PaginatorComponent,
            'favorite-product': favoritProductComponent
        },
        template: $('#visualizationsApp').html(),
        methods: {
            makeFetchesForTabs: function () {
                if (this.activeTab == 1 && !this.productsFetched) {
                    this.fetchProducts(productsPage, false);
                    this.productsFetched = true;
                }
                else if (this.activeTab == 3 && !this.apartmentProductsFetched) {
                    this.fetchApartmentProducts(apartmentProductsPage, false);
                    this.apartmentProductsFetched = true;
                }
            },
            switchTab: function (tabIndex) {
                if (this.activeTab == tabIndex) {
                    return;
                }

                this.activeTab = tabIndex;
                this.refreshPlugins();
                this.makeFetchesForTabs();

                const url = new URL(window.location.href);

                // Set or update the 'activeTab' query parameter
                url.searchParams.set('activeTab', this.activeTab);

                // Push the new URL to the browser history
                window.history.pushState({}, '', url);
            },
            fetchVisualizations: function () {
                var _self = this;

                if (_self.allVisualizations.length) {
                    return;
                }

                _self.isLoaded = false;
                _self.fetch('get', '/izba/' + apartmentId, {}, function (response) {
                    if (!response.status) {
                        return;
                    }

                    _self.allVisualizations = response.visualizations;
                    _self.allProductsCount = response.products_count;
                    _self.apartmentProductsCount = response.apartment_products_count;

                    if (_self.allVisualizations && !Array.isArray(_self.allVisualizations)) {
                        _self.allVisualizations = Object.values(_self.allVisualizations);
                    }

                    _self.isLoaded = true;

                    _self.refreshPlugins();
                    _self.makeFetchesForTabs();
                }, { timeout: _debug ? 1e6 : 150000 });
            },
            fetchBase: function (page, addMore, fetchUrl, productsKey) {
                var _self = this;

                _self.isLoaded = false;

                _self.fetch('get', fetchUrl, { page: page }, function (response) {
                    if (!response.status) {
                        return;
                    }

                    if (!addMore) {
                        _self[productsKey] = response.products;
                    } else {
                        _self[productsKey] = _self[productsKey].concat(response.products);
                    }

                    _self.isLoaded = true;
                });
            },
            fetchProducts: function (page, addMore) {
                var $listingMain = $('.js-tab-listing-main:visible');

                this.fetchBase(page, addMore, this.productsUrl, 'products');

                const url = new URL(window.location.href);
                url.searchParams.set('productsPage', page);
                window.history.pushState({}, '', url);

                if (!addMore && $listingMain.length && this.productsFetched) {
                    slideTo($listingMain, 30);
                }
            },
            fetchApartmentProducts: function (page, addMore) {
                var $listingMain = $('.js-tab-listing-main:visible');

                this.fetchBase(page, addMore, this.apartmentProductsUrl, 'apartmentProducts');

                const url = new URL(window.location.href);
                url.searchParams.set('apartmentProductsPage', page);
                window.history.pushState({}, '', url);

                if (!addMore && $listingMain.length && this.apartmentProductsFetched) {
                    slideTo($listingMain, 30);
                }
            },
            loadMoreProducts: function (page) {
                this.fetchProducts(page, true)
            },
            loadMoreApartmentProducts: function (page) {
                this.fetchApartmentProducts(page, true)
            },
            addVisualizationToCart: function (event) {
                if (!this.visualization) {
                    return;
                }

                const button = event.target;

                button.classList.add('is-loading');

                this.fetch('post', '/nakup-vizualizacie', {
                    id: this.visualization.id
                }, function () {
                    button.classList.remove('is-loading');
                    button.classList.add('is-loaded');

                    if (RshopApp._isMounted) {
                        store.dispatch('fetchCart');
                    }

                    setTimeout(() => {
                        button.classList.remove('is-loaded');
                    }, 500);
                }, 'json')
            },
            addProductToCart: function (product) {
                const refs = this.$refs;

                let button = refs[`projectThumbBuy${product.id}`][0];

                button.classList.add('is-loading');

                rEvent.on('Cart.addedProduct', function (data) {
                    button = refs[`projectThumbBuy${data.response.item.product_id}`][0];

                    button.classList.remove('is-loading');
                    button.classList.add('is-loaded');

                    setTimeout(() => {
                        button.classList.remove('is-loaded');
                    }, 500);
                });

                this.$store.dispatch('addCartItem', {
                    product_id: product.id,
                    product_variation_id: product.product_variation_id,
                    module_data: product.module_data,
                    quantity: 1,
                    custom_project_apartment_id: product.custom_project_apartment_id
                });
            },
            refreshPlugins: function () {
                this.$nextTick(function () {
                    // image lazy loader
                    if (typeof bLazy !== 'undefined') {
                        bLazy.revalidate();
                        //bLazyProjects.revalidate();
                    }

                    // sliders
                    swipers.tabVariants.elem = $('.js-tab-variants-slider');
                    swipers.tabListing.elem = $('.js-tab-listing-slider');
                    checkSliders(swipers);

                    for (const sliderName in swipers) {
                        if (swipers[sliderName].active) {
                            swipers[sliderName].slider.update();
                            swipers[sliderName].slider.slideTo(0, 0, false);
                        }
                    }

                    // lightbox
                    buildLightboxSlider();
                });
            },
            changeVisualisationActiveTab: function (key) {
                this.activeVisualizationIndex = key;

                this.refreshPlugins();

                const url = new URL(window.location.href);
                url.searchParams.set('activeVisualisationTab', this.activeVisualizationIndex);
                window.history.pushState({}, '', url);
            }
        },
        computed: {
            visualization: function () {
                if (!this.allVisualizations.length) {
                    return null;
                }

                return this.allVisualizations[this.activeVisualizationIndex];
            },
            visualizationPrice: function () {
                // TODO: v buducnosti sa moze zmenit? treba mat v mysli
                var taxPercentage = 23;

                return this.visualizationPriceVat / (1 + taxPercentage / 100);
            },
            visualizationPriceVat: function () {
                // TODO: v buducnosti sa moze zmenit? treba mat v mysli
                var taxRate = 1.23,
                    assemblyPrice = 0;

                if (!this.visualization) {
                    return 0;
                }

                if (this.visualization.assembly_price) {
                    assemblyPrice = this.visualization.assembly_price;
                }

                if (this.visualization.price_vat) {
                    assemblyPrice = assemblyPrice * taxRate;

                    return this.visualization.price_vat + assemblyPrice;
                }

                return this.visualization.products_price_vat + assemblyPrice;
            },
            visualizationSavings: function () {
                if (!this.visualization || !this.visualization.price_vat) {
                    return 0;
                }

                var taxRate = 1.23,
                    assemblyPrice = 0;

                if (this.visualization.assembly_price) {
                    assemblyPrice = this.visualization.assembly_price * taxRate;
                }

                var result = this.visualization.products_price_vat + assemblyPrice - this.visualizationPriceVat;

                return result > 0 ? result : 0;
            },
            bundleProducts: function () {
                if (!this.visualization) {
                    return [];
                }

                return this.visualization.products;
            },
            manufacturers: function () {
                if (!this.visualization) {
                    return [];
                }

                return this.visualization.manufacturers;
            },
            allVisualizationsImages: function () {
                if (!this.allVisualizations.length) {
                    return [];
                }

                let allImages = [];

                this.allVisualizations.forEach(function (visualization) {
                    if (!visualization.images.length) {
                        return true;
                    }

                    visualization.images.forEach(function (image) {
                        allImages.push(image);
                    });
                });

                return allImages;
            },
        }
    });
}

let swipers = {
    tabListing: {
        slider: false,
        elem: $('.js-tab-listing-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            navigation: {
                nextEl: '.js-tab-listing-slider-next',
                prevEl: '.js-tab-listing-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            on: {
                init: function () {
                    swipers.tabListing.active = true;
                },
                slideChange: function () {
                    bLazy.revalidate()

                    setTimeout(function () {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    tabVariants: {
        slider: false,
        elem: $('.js-tab-variants-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            navigation: {
                nextEl: '.js-tab-variants-slider-next',
                prevEl: '.js-tab-variants-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            on: {
                init: function () {
                    swipers.tabVariants.active = true;
                },
                slideChange: function () {
                    bLazy.revalidate()

                    setTimeout(function () {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    }
}

function buildLightboxSlider() {
    $('.js-lightbox-project-slider').each(function (k, v) {
        if ($(this).data('lightGallery')) {
            $(this).data('lightGallery').destroy(true);
        }

        $(this).lightGallery(
            $.extend({}, lightGallerySettings, {
                selector: '.js-lightbox-item',
                galleryId: k,
                mode: 'lg-fade',
                appendSubHtmlTo: '.lg-item',
                closable: false,
                hash: false
            })
        );

        $(this).on('onBeforeOpen.lg', function () {
            freezeScroll();
        });

        $(this).on('onCloseAfter.lg', function () {
            unfreezeScroll();
        });
    });
}

rEvent.on('Window.resized', function () {
    checkSliders(swipers);
});

$(function () {
    checkSliders(swipers);

    $('.js-projects-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass('is-loading');
            $('.js-projects-login-error').slideUp(100);

            Form.ajaxPost(form, function (data) {
                if (!data.status) {
                    $('.js-projects-login-error')
                        .text(data.message)
                        .slideDown(150);
                } else {
                    $('.js-projects-login-hide').slideUp(150);
                    $('.js-projects-login-success').slideDown(150);

                    location.reload();
                }

                $(form).find('button[type="submit"]').removeClass('is-loading');
            }, 'json');
        }
    });

    /*bLazyProjects = new Blazy({
        selector: '.js-blazy-projects',
        container: '.js-blazy-projects-container',
        successClass: 'is-loaded',
        success: function (ele) {
            var url = $(ele).css('background-image');

            ele.style.setProperty('background-image', url, 'important');
        }
    });*/
});
